import { useAppSelector } from '@/shared/hooks';
import { isNativeFullscreenSupported } from '@/shared/lib';

import { selectors } from '../model';

// Where the browser has no Fullscreen API (iPhone Safari) the expand state is
// emulated with CSS by the report render container instead of the browser
export const useIsPseudoFullscreen = (): boolean => {
  const isExpanded = useAppSelector(
    selectors.selectToolbarProperty('main', 'expand'),
  );

  return isExpanded && !isNativeFullscreenSupported();
};
